const benefitactivity = {
	path: '/benefitactivity',
	name: 'benefitactivity',
	component: () => import("@views/benefit-activity/benefit-activity.vue"),
	children: [
		{
			path: 'index',
			component: () => import("@views/benefit-activity/index.vue"),
			meta: {
				// tabBar: false
			}
		},
		{
			path: 'my-benefit',
			component: () => import("@views/benefit-activity/my-benefit.vue"),
			meta: {
				// tabBar: false
			}
		},
		{
			path: 'activity_detail',
			component: () => import("@views/benefit-activity/activity_detail.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path: 'load-comment',
			component: () => import("@views/benefit-activity/load-comment.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path: 'benefit-search',
			component: () => import("@views/benefit-activity/benefit-search.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path: 'sign-up',
			component: () => import("@views/benefit-activity/sign-up.vue"),
			meta: {
				tabBar: false
			}
		},
		{
			path: 'sign-success',
			component: () => import("@views/benefit-activity/sign-success.vue"),
			meta: {
				tabBar: false
			}
		},
    {
      path: 'dynamic-intro',
      component: () => import("@views/benefit-activity/dynamic-intro.vue"),
      meta: {
        tabBar: false
      }
    },
    {
      path: 'load-comment',
      component: () => import("@views/benefit-activity/load-comment.vue"),
      meta: {
        tabBar: false
      }
    }
	]
};

export default benefitactivity
